export let QboStatusFilter = /*#__PURE__*/function (QboStatusFilter) {
  QboStatusFilter["All"] = "";
  QboStatusFilter["Synced"] = "synced";
  QboStatusFilter["NotSynced"] = "notSynced";
  return QboStatusFilter;
}({});